import { textToSlug } from './textToSlug'

export function textToTarget(title?: string, headingType?: string) {
  const target = textToSlug(title, headingType)

  return `scroll=false&target=${target}`
}
